// Module name
export const MODULE_NAME = 'search';

export let global_vars = {};

function init_cse(global, cx) {
    let gcse = global.document.createElement('script');
    gcse.type = 'text/javascript';
    gcse.async = true;
    gcse.src = `https://cse.google.com/cse.js?cx=${cx}`;
    let s = global.document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(gcse, s);
}

export function initialize(global) {
    let lang = global.document.querySelector('body').dataset.lang;
    let cx;
    if (lang === 'en') {
        cx = '013043526628355632736:9o5nbr6z9qy';
    } else if (lang === 'fr') {
        cx = '013043526628355632736:nputj0j_eoa';
    } else if (lang === 'zh') {
        cx = '013043526628355632736:mraksb7kwyo';
    } else {
        throw new Error(`Unexpected language: ${lang}`);
    }
    init_cse(global, cx);
}
